<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="memberStatusData === null">Create Member Status</span>
      <span v-else>Update Member Status</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Membership Program" required>
              <a-select
                v-model="formData.membership_program_id"
                :disabled="viewMode || memberStatusData !== null"
              >
                <a-select-option
                  v-for="membershipProgram in membershipPrograms"
                  :key="membershipProgram.id"
                  :value="membershipProgram.id"
                >
                  {{ membershipProgram.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.membership_program_id.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.membership_program_id.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="
                  viewMode ||
                  (memberStatusData !== null &&
                    memberStatusData.name === 'Inactive')
                "
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Status">
              <a-select
                v-model="formData.status"
                :disabled="
                  viewMode ||
                  (memberStatusData !== null &&
                    memberStatusData.name === 'Inactive')
                "
              >
                <a-select-option value="A"> Active </a-select-option>
                <a-select-option value="I"> Inactive </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Description">
              <a-textarea
                v-model="formData.description"
                :auto-size="{ minRows: 3, maxRows: 3 }"
                :disabled="viewMode"
              />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input>
              <b-form-checkbox
                v-model="redemptionFlag"
                name="check-button"
                switch
                :disabled="viewMode"
              >
                <label class="form-control-label">Redemption Flag</label>
              </b-form-checkbox>
            </base-input>
          </div>

          <div class="col">
            <base-input>
              <b-form-checkbox
                v-model="earningFlag"
                name="check-button"
                switch
                :disabled="viewMode"
              >
                <label class="form-control-label">Earning Flag</label>
              </b-form-checkbox>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Sales Invoice Message">
              <a-select
                v-model="formData.sales_invoice_message_id"
                :disabled="viewMode"
              >
                <a-select-option
                  v-for="message in messages"
                  :key="message.id"
                  :value="message.id"
                >
                  {{ message.title }}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="memberStatusData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createMemberStatus"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="confirmUpdate"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'MemberStatusForm',
  props: {
    memberStatusData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      formData: {
        membership_program_id: null,
        name: null,
        description: null,
        earning_flag: false,
        redemption_flag: false,
        sales_invoice_message_id: null,
        status: 'A'
      },
      membershipPrograms: [],
      messages: []
    };
  },
  validations: {
    formData: {
      membership_program_id: {
        required
      },
      name: { required }
    }
  },
  methods: {
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getMessages(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/messages`
      );
      this.messages = data.sort((a, b) => a.title.localeCompare(b.title));
    },
    async createMemberStatus() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_member_statuses',
          {
            member_status: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      }
    },
    async editMemberStatus() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_member_statuses/' + this.memberStatusData.id,
          {
            member_status: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      }
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to commit the changes you made?',
        onOk: () => {
          this.editMemberStatus();
        }
      });
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.formData = {
        membership_program_id: null,
        name: null,
        description: null,
        earning_flag: false,
        redemption_flag: false,
        sales_invoice_message_id: null,
        status: 'A'
      };
    },
    setFormData(data = null) {
      if (data !== null) {
        const {
          membership_program_id,
          name,
          description,
          earning_flag,
          redemption_flag,
          sales_invoice_message_id,
          status
        } = data;

        this.getMessages(membership_program_id);

        this.formData = {
          membership_program_id,
          name,
          description,
          earning_flag,
          redemption_flag,
          sales_invoice_message_id,
          status
        };
      }
    }
  },
  created() {
    this.getMembershipPrograms();
    this.setFormData(this.memberStatusData);
  },
  watch: {
    memberStatusData: function (newVal) {
      if (newVal !== null) {
        this.setFormData(newVal);
      } else {
        this.clearForm();
      }
    },

    'formData.membership_program_id': function (val) {
      if (val !== null) {
        this.getMessages(val);
      }
    },

    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  },
  computed: {
    earningFlag: {
      get() {
        return this.formData.earning_flag ? true : false;
      },
      set(val) {
        this.formData.earning_flag = val;
      }
    },
    redemptionFlag: {
      get() {
        return this.formData.redemption_flag ? true : false;
      },
      set(val) {
        this.formData.redemption_flag = val;
      }
    }
  }
};
</script>

<style scoped></style>
